<div class="fz-dialog">
  <div class="fz-dialog__root">
    <!-- Illustration -->
    <div class="fz-dialog__picture">
      <picture>
        <img
          srcset="/shared/img/user_verification_success.svg"
          alt="Verification Success Illustration"
        />
      </picture>
    </div>

    <!-- content -->
    <div class="fz-dialog__content">
      <h2 class="fz-dialog__content__title" [innerHTML]="config.title">></h2>
      <p class="fz-dialog__content__subtitle" [innerHTML]="config.message"></p>
    </div>

    <!-- actions -->
    <div class="fz-dialog__actions">
      <a
        *ngIf="page !== 'claim-prize'"
        mat-flat-button
        color="primary"
        class="fz-button--medium"
        [href]="config.primaryActionRoute"
      >
        {{ config.primaryActionLabel }}
      </a>
      <a
        *ngIf="page !== 'claim-prize'"
        mat-stroked-button
        color="primary"
        class="fz-button--medium"
        [href]="config.secondaryActionRoute"
      >
        {{ config.secondaryActionLabel }}
      </a>

      <button
        *ngIf="page === 'claim-prize'"
        mat-flat-button
        color="primary"
        mat-dialog-close
      >
        Continue to claim prize
      </button>
    </div>
  </div>
</div>
